import { render, staticRenderFns } from "./synchronization.vue?vue&type=template&id=6d4a9590&scoped=true&"
import script from "./synchronization.vue?vue&type=script&lang=js&"
export * from "./synchronization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a9590",
  null
  
)

export default component.exports